import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ICustomerImportResult } from "../../shared/interfaces/customer/ICustomer";

interface IProps {
  show: boolean;
  handleClose: () => void;
  result: ICustomerImportResult | null;
}

const CustomerImportResultModal = ({ show, handleClose, result }: IProps) => {
  const { t } = useTranslation();
  const created = result?.created ?? [];
  const skipped = result?.skipped ?? [];

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      className="fade zoomIn"
      dialogClassName="modal-dialog-centered"
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("customer.importResult")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {result?.message && <p className="mb-3">{result.message}</p>}

        <div className="d-flex gap-2 mb-3">
          <span className="badge bg-success">
            {t("customer.importCreated")}: {created.length}
          </span>
          <span className="badge bg-warning">
            {t("customer.importSkipped")}: {skipped.length}
          </span>
        </div>

        {!!skipped.length && (
          <div className="table-responsive" style={{ maxHeight: "50vh" }}>
            <table className="table table-sm table-hover mb-0">
              <thead>
                <tr>
                  <th style={{ width: "80px" }}>{t("customer.importRow")}</th>
                  <th>{t("customer.importReason")}</th>
                </tr>
              </thead>
              <tbody>
                {skipped.map((item, index) => (
                  <tr key={`${item.row}-${index}`}>
                    <td>{item.row}</td>
                    <td>{item.reason}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {!skipped.length && (
          <p className="text-muted mb-0">{t("customer.importNoSkipped")}</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          {t("general.close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomerImportResultModal;
